import React from 'react';
import { Button } from '@mui/material';

/**
 * @typedef {object} ActionButtonGroupProps
 * @property {boolean} [isEdit]
 * @property {boolean} [isSubmitDisabled]
 * @property {boolean} isSubmitting
 * @property {string} [submitButtonText]
 * @property {string} [submitForm]
 * @property {'button' | 'submit'} [submitButtonType]
 * @property {boolean} [disabled]
 * @property {(event?: React.MouseEvent) => void} handleCancelClick
 * @property {(event?: React.MouseEvent) => void} handleSubmitClick
 * @property {(event?: React.MouseEvent) => void} [handleEditClick]
 */

/**
 * @param {ActionButtonGroupProps} props
 */
const ActionButtonGroup = props => {
  const {
    isEdit = true,
    isSubmitDisabled = false,
    isSubmitting,
    submitForm,
    submitButtonType,
    submitButtonText = 'Submit',
    disabled = false,
    handleCancelClick,
    handleEditClick,
    handleSubmitClick
  } = props;

  return (
    <>
      {isEdit ? (
        <div className='action-buttons-edit-group'>
          <Button
            data-testid='cancel-button'
            className='secondary-button sm'
            disabled={isSubmitting}
            onClick={handleCancelClick}>
            Cancel
          </Button>
          <Button
            data-testid='submit-button'
            className='primary-button sm'
            disabled={isSubmitDisabled || isSubmitting}
            form={submitForm}
            type={submitButtonType || 'button'}
            onClick={handleSubmitClick}>
            {submitButtonText}
          </Button>
        </div>
      ) : (
        <div>
          <Button
            data-testid='edit-button'
            className='primary-button sm'
            disabled={disabled}
            onClick={handleEditClick}>
            Edit
          </Button>
        </div>
      )}
    </>
  );
};

export default ActionButtonGroup;
